import 'core-js/stable';
import T from 'prop-types';
import React from 'react';
import './globals';
import { DynamicFormErrorBoundary } from './module';
import { DynamicForm } from './module/DynamicForm';

export {
  DetailedError,
  extendKeyPath,
  formNameFromKeyPath,
  getFieldName,
  getSchemaAtCursor,
  getTranslationScopePath,
  localizationKeyPath,
  pruneUnwantedProperties,
  reducei18n,
  requiredArg,
  translationsForKeyPath,
  useFormikSync,
  useUpdateFieldContext,
} from './module/utils';

export {
  pairValuesWithLabels,
  transformEnumsAtSchemaNode,
} from './module/operators';

export {
  Markdown as DynamicFormMarkdown,
  MarkdownTranslation as DynamicFormMarkdownTranslation,
  renderMarkdown as renderDynamicFormMarkdown,
} from './module/Markdown';

export {
  Locale as DynamicFormLocale,
  Optional as DynamicFormOptional,
  Translation as DynamicFormTranslation,
  Translations as DynamicFormTranslations,
  TranslationScope as DynamicFormTranslationScope,
  NavigationContextProvider as DynamicFormNavigationContextProvider,
  useProductCodes,
  useTranslations,
  useCultureConfiguration,
  useNavigationContext,
} from './module/context';

export {
  DynamicFormFieldFeedback,
  DynamicFormField,
  DynamicFormHint,
  DynamicFormInput,
  DynamicFormLabel,
  DynamicFormMoreInfo,
} from './module';

const DynamicFormModule = React.forwardRef((props, ref) => (
  <DynamicFormErrorBoundary isRoot title="An error occurred">
    <DynamicForm {...props} ref={ref} />
  </DynamicFormErrorBoundary>
));

DynamicFormModule.displayName = 'DynamicFormModule';

DynamicFormModule.propTypes = {
  formSchema: T.object.isRequired,
  translations: T.object.isRequired,
  culture: T.object.isRequired,
  onSubmit: T.func.isRequired,
  customComponents: T.object,
  customPages: T.object,
  showProgressIndicator: T.bool,
  initialValues: T.object,
  productCodes: T.object,
  extendAjv: T.func,
};

export default DynamicFormModule;
